import React from 'react';
import Link from 'next/link';
import { cropArray } from '../../Data/CropsData';
import Image from 'next/image';
import MetaHead from '@/Components/MetaHead';

export default function index() {
  return (
    <main className="py-8 px-4 mx-auto max-w-screen-xl text-left lg:py-16 lg:px-6">
      <MetaHead title="Crops | Agronomy Models of Crops | Fyllo" />
      <div className="mx-auto max-w-screen-sm">
        <h2 className=" mb-4 md:mb-8 text-4xl font-extrabold tracking-tight leading-none md:text-5xl xl:text-4xl  text-center text-fyllo-800">
          Agronomy Models
        </h2>
        <p className=" mb-6 font-light text-gray-500 lg:mb-8 md:text-lg lg:text-xl  text-center">
          We have researched and worked on 20+ crops across horticulture, plantation, fibres and agriculture. We have
          100+ models for precise irrigation, fertigation, disease and pest models.
        </p>
      </div>
      <div className="grid  grid-cols-2 md:grid-cols-4 gap-2 md:gap-8 ">
        {cropArray.map((crop, i) => {
          return (
            <Link
              href={`/crop/${crop.text}`}
              className="bg-slate-50 relative rounded hover:rounded-2xl transition-all  hover:scale-110"
              key={i}
            >
              <Image
                className="rounded-2xl hover:scale-110"
                src={crop.image.png}
                alt={crop.text}
                sizes="(max-width: 768px) 100vw,
              (max-width: 1200px) 50vw,
              33vw"
              />
              <div className="absolute top-0  w-full h-full flex items-center justify-center opacity-0 hover:opacity-100 hover:bg-[rgba(0,0,0,0.6)] hover:rounded-2xl  transition-all">
                <p className="text-white text-3xl">{crop.title}</p>
              </div>
            </Link>
          );
        })}
      </div>
    </main>
  );
}
